'use strict';
angular.module('more.ui.form').directive('placeholderImage', function () {
  return {
    restrict : 'E',
    replace : true,
    template : '<i class="icon ion-image" style="color:#CBCBCB;font-size:240px;"></i>',
    scope : false
  };
});
